import { useEffect } from "react";
import SignupBox from "../components/signup/SignupBox";

export default function SignupPage() {
    useEffect(() => {
        document.title = "Sign up"
    }, [])

    return (
        <SignupBox />
    );
}